import { render, staticRenderFns } from "./listreqpurchases.vue?vue&type=template&id=c4b04798&scoped=true"
import script from "./listreqpurchases.vue?vue&type=script&lang=js"
export * from "./listreqpurchases.vue?vue&type=script&lang=js"
import style0 from "./listreqpurchases.vue?vue&type=style&index=0&id=c4b04798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b04798",
  null
  
)

export default component.exports